import { ReactNode, useRef } from "react";
import { Container, Navbar as BsNavBar } from "react-bootstrap";
import { useHover } from "../../hooks/useHover";
import FableousLogo from "../graphic/FableousLogo";
import FableousTitle from "../graphic/FableousTitle";
import { NavCollapse } from "./NavCollapse";
import { useWindowDimensions } from "@fableous/ui/hooks/useWindowDimensions";

export default function Navbar({ navComponent, hidden }: { navComponent: ReactNode; hidden?: boolean }) {
	const navRef = useRef<HTMLDivElement>(null);
	const divRef = useRef<HTMLDivElement>(null);
	const [hoveringNav, recentHoveringNav] = useHover(navRef);
	const [hoveringDiv] = useHover(divRef);
	const {metBreakpoint} = useWindowDimensions();

	return (
		<>
			<div className="hover-trigger" ref={divRef} />
			<BsNavBar
				ref={navRef}
				fixed="top"
				collapseOnSelect
				expand="md"
				className={`bg-white border border-shadow text-shadow hover-navbar${hoveringDiv || hoveringNav || recentHoveringNav || !hidden ? " show" : ""}`}
			>
				<Container>
					<div className="d-flex align-items-center">
						<BsNavBar.Brand href="/" className="link-no-decoration mt-0">
							<FableousLogo maxHeight={30} />
						</BsNavBar.Brand>
						<BsNavBar.Brand href="/" className="link-no-decoration mt-0 ms-2 flex-shrink-0">
							<FableousTitle maxHeight={20} />
						</BsNavBar.Brand>
					</div>
					<NavCollapse collapsed={!metBreakpoint("md")}>
						{navComponent}
					</NavCollapse>
				</Container>
			</BsNavBar>
		</>
	);
}
